import { useRecoilCallback } from 'recoil'
import {
  editorClipboardAtom,
  itemAtomFamily,
  itemIdAtom,
  selectedItemsAtom,
} from 'atoms'
import { unsavedChangesAtom } from '@/atoms/_editorAtoms'
import { isEditorTextBoxItem } from '@/utils/editor-text-box/editorTextBoxAdapter'
import { useEditorPasteTextBoxFromClipboard } from '@/hooks/editor/useEditorPasteTextBoxFromClipboard'
import { v4 as uuidv4 } from 'uuid'

export const usePasteItemFromClipboard = () => {
  const pasteTextBox = useEditorPasteTextBoxFromClipboard()

  return useRecoilCallback(
    ({ snapshot, set }) =>
      async () => {
        const clipboard = await snapshot.getPromise(editorClipboardAtom)
        const source = clipboard[0]
        if (!source) return

        if (isEditorTextBoxItem(source)) {
          const newBoxId = await pasteTextBox(source)
          if (newBoxId) set(selectedItemsAtom, [newBoxId])
          return
        }

        const itemIds = await snapshot.getPromise(itemIdAtom)
        const copiedItem = { ...source }
        copiedItem.id = uuidv4()
        copiedItem.x = parseInt(copiedItem.x) + 15
        copiedItem.y = parseInt(copiedItem.y) + 15

        set(itemAtomFamily(copiedItem.id), copiedItem)
        set(itemIdAtom, [...itemIds, copiedItem.id])
        set(editorClipboardAtom, [copiedItem])
        set(selectedItemsAtom, [copiedItem.id])
        set(unsavedChangesAtom, true)
      },
    [pasteTextBox],
  )
}

export default usePasteItemFromClipboard
